import { mapDataSource, RawDataSource } from '~/Api/DataSource';

import ComparativePriceProduct from './ComparativePriceProduct';

export interface RawComparativePriceProduct {
	id: string;
	dataSource: RawDataSource;
}

export default function mapComparativePriceProduct(product: RawComparativePriceProduct): ComparativePriceProduct {
	return new ComparativePriceProduct(product.id, mapDataSource(product.dataSource));
}
